import { gql } from '@apollo/client';

export * from './appLogoDirectUpload.mutation.generated';

export const APP_LOGO_DIRECT_UPLOAD = gql`
  mutation appLogoDirectUpload($input: AppLogoDirectUploadInput!) {
    appLogoDirectUpload(input: $input) {
      errors
      success
      headers
      signedId
      url
    }
  }
`;
